import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 24px;

  @media (max-width: 1117px) {
    align-items: flex-end;
  }

  @media (max-width: 870px) {
    flex-direction: column;
  }
`;

const Filters = styled.div`
  > * {
    margin-right: 8px;
    margin-bottom: 8px;
  }
`;

const MoreAction = styled.div`
  margin-bottom: 8px;
  @media (max-width: 870px) {
    margin-top: 16px;
    margin-bottom: unset;
  }
`;

export { Container, Filters, MoreAction };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/QuickFiltersStyle.js